import { CheckBox, Grid, Input, Picker, Row, Button, Form } from 'components'
import { isEmptyOrAfter, isEmptyOrBefore } from 'components/DatePicker/utils'
import { MagnifyingGlassIcon } from 'components/Icons'
import { ISearchWalletParams } from 'services/NGT/Wallet'
import { SPACING } from 'utils'


interface IFilterCre {
  setDateErrors?: (value: any) => void
  dateErrors?: any
  handleSearch: (_isClick?: boolean, _isClear?: boolean, form?: ISearchWalletParams) => void
  handleClear: () => void
  isSearchDisabled: boolean
  control: any
  errors: any
  handleSubmit: any
}


export const FilterCre = ({
  handleSearch,
  control,
  errors,
  isSearchDisabled,
  handleSubmit,
  handleClear
}: IFilterCre) => {


  function handleSubmitForm(form: ISearchWalletParams) {

    handleSearch(true, false, form)
  }

  return (
    <>
      <Form
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <>
          <Grid
            gridCols="1fr 2fr 1fr 1fr 2fr 1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
          >
            <Input
              control={control}
              label="Contrato"
              placeholder="Nº"
              formValue="CdContrato"
              // value={form.CdContrato}
              // onChange={onChange}
              maxLength={100}
            />
            <Input
              control={control}
              label="Fornecedor"
              placeholder="Nome do Fornecedor"
              formValue="NmFornecedor"
              // value={form.NmFornecedor}
              // onChange={onChange}
              maxLength={100}
            />
            <Picker
              control={control}
              // onChange={(date) =>
              //   onChange({ target: { name: 'NuAnoMesCompetenciaInicial', value: date } })
              // }
              label="Competência Inicial"
              inputFormat="MM/yyyy"
              showClearButton={false}
              views={['month', 'year']}
              placeholder="mm/aaaa"
              formValue='NuAnoMesCompetenciaInicial'
              // defaultValue={form.NuAnoMesCompetenciaInicial || null}
              // customError={(dateErrors && dateErrors.CompetenciaInicial) || null}
              // value={form.NuAnoMesCompetenciaInicial || null}
              type="monthAndYear"
            />
            <Picker
              control={control}
              // onChange={(date) =>
              //   onChange({ target: { name: 'NuAnoMesCompetenciaFinal', value: date } })
              // }
              label="Competência Final"
              inputFormat="MM/yyyy"
              // minDate={form.NuAnoMesCompetenciaInicial}
              showClearButton={false}
              hasError={true}
              formValue='NuAnoMesCompetenciaFinal'
              views={['month', 'year']}
              errors={errors}
              placeholder="mm/aaaa"
              // defaultValue={form.NuAnoMesCompetenciaFinal || null}
              // customError={(dateErrors && dateErrors.CompetenciaFinal) || null}
              // value={form.NuAnoMesCompetenciaFinal || null}
              type="monthAndYear"
            />
            <Input
              control={control}
              label="Nº CRE"
              placeholder="Nº"
              formValue="CdCRE"
              // value={form.CdCRE}
              // onChange={onChange}
              maxLength={100}
            />
            <Input
              control={control}
              label="Analista"
              placeholder="Nome do Analista"
              formValue="NmAnalista"
              // value={form.NmAnalista}
              // onChange={onChange}
              maxLength={100}
            />
          </Grid>
          <Grid
            gridCols="1fr 1fr 6fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing30} 0`}
          >
            <Picker
              control={control}
              label="Data Entrada"
              // value={form.DtAnalise || null}
              errors={errors}
              formValue='DtAnalise'
            // maxDate={form.DtUltimaAnalise || null}
            // onChange={(date) =>
            //   onChange({ target: { name: 'DtAnalise', value: date } })
            // }
            />
            <Picker
              control={control}
              label="Data Ult. Análise"
              errors={errors}
              // value={form.DtUltimaAnalise || null}
              // minDate={form.DtAnalise || null}
              formValue='DtUltimaAnalise'
            // onChange={(date) =>
            //   onChange({ target: { name: 'DtUltimaAnalise', value: date } })
            // }
            />
          </Grid>
          <Row alignItems="center" justifyContent="space-between" gap="1rem">
            <Row alignItems="center">
              <CheckBox
                control={control}
                // onChange={(e) =>
                //   onChange({
                //     target: { name: 'FlMobilizacao', value: e.target.checked }
                //   })
                // }
                formValue='FlMobilizacao'
                label="1ª Mobilização"
                onClick={null}
              // checked={form.FlMobilizacao}
              />
              <CheckBox
                control={control}
                // onChange={(e) =>
                //   onChange({
                //     target: { name: 'FlMedicao', value: e.target.checked }
                //   })
                // }
                label="Ult. Mobilização"
                // checked={form.FlMedicao}
                formValue='FlMedicao'
                onClick={null}
              />
              <CheckBox
                control={control}
                // onChange={(e) =>
                //   onChange({
                //     target: { name: 'FlDenuncia', value: e.target.checked }
                //   })
                // }
                label="Denúncia"
                // checked={form.FlDenuncia}
                formValue='FlDenuncia'
                onClick={null}
              />
              <CheckBox
                control={control}
                // onChange={(e) =>
                //   onChange({
                //     target: { name: 'FlProjeto', value: e.target.checked }
                //   })
                // }
                label="Projeto"
                // checked={form.FlProjeto}
                formValue='FlProjeto'
                onClick={null}
              />
              <CheckBox
                control={control}
                // onChange={(e) =>
                //   onChange({
                //     target: { name: 'FlAlerta', value: e.target.checked }
                //   })
                // }
                label="Alerta"
                formValue='FlAlerta'
                // checked={form.FlAlerta}
                onClick={null}
              />
              <CheckBox
                control={control}
                // onChange={(e) =>
                //   onChange({
                //     target: { name: 'flTodos', value: e.target.checked }
                //   })
                // }
                label="Todos"
                // checked={form.flTodos}
                formValue='flTodos'
                onClick={null}
              />
            </Row>

            <Row alignItems="center">
              <Button onClick={handleClear} variantButton="text" text="LIMPAR" />
              <div style={{ width: 20 }}></div>
              <Button
                type='submit'
                disabled={isSearchDisabled}
                endIcon={<MagnifyingGlassIcon />}
                text="PESQUISAR"
              />
            </Row>
          </Row >
        </>
      </Form>
    </>
  )
}
